module.exports = __webpack_public_path__ + "img/mexc.9b4d0cc0.png";